import React from "react";
import { Download, FileSpreadsheet, X } from "lucide-react";
import { excelExportUrl } from "../../lib/api";

export default function BerichtModal({ open, onClose }) {
  if (!open) return null;
  const today = new Date().toLocaleDateString("de-DE", {
    day: "2-digit", month: "long", year: "numeric",
  });

  return (
    <>
      <div onClick={onClose} className="fixed inset-0 bg-navy/30 z-40" />
      <div
        data-testid="bericht-modal"
        className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(640px,95vw)] bg-white border border-navy/15 z-50"
      >
        <div className="border-b border-navy/10 px-6 py-4 flex items-center justify-between">
          <div>
            <div className="pb-eyebrow">Datenexport</div>
            <h3 className="font-display font-semibold text-navy text-xl mt-1 tracking-tight">
              Investoren-Export
            </h3>
          </div>
          <button data-testid="bericht-modal-close" onClick={onClose} aria-label="Modal schließen" className="text-navy/60 hover:text-navy min-w-[44px] min-h-[44px] -mr-2.5 inline-flex items-center justify-center">
            <X size={18} />
          </button>
        </div>

        <div className="px-6 py-6 space-y-5 text-sm font-sans text-navy/85">
          <p className="text-navy/70">
            Stand: <strong className="text-navy">{today}</strong>
          </p>

          <div className="border border-navy/15">
            <div className="px-5 py-4 border-b border-navy/10">
              <div className="flex items-start gap-3">
                <FileSpreadsheet size={22} className="text-heiss mt-0.5" strokeWidth={1.5} />
                <div className="flex-1">
                  <h4 className="font-display font-semibold text-navy text-base tracking-tight">
                    Excel-Komplettexport (.xlsx)
                  </h4>
                  <p className="text-xs text-navy/60 mt-0.5">
                    Alle Investoren · 35 Spalten inkl. Phase, Einstufung, Sperren, NDA, Primärkontakt
                  </p>
                </div>
              </div>
            </div>
            <div className="px-5 py-3 bg-ledger/50">
              <a
                href={excelExportUrl()}
                download
                data-testid="download-excel-btn"
                className="pb-btn-outline text-xs uppercase tracking-widish font-semibold inline-flex items-center gap-2"
              >
                <Download size={13} /> Excel herunterladen
              </a>
            </div>
          </div>

          <p className="text-xs text-navy/50 border-t border-navy/10 pt-3">
            Hinweis: Der Export basiert auf dem aktuellen Datenstand zum Klickzeitpunkt.
          </p>
        </div>
      </div>
    </>
  );
}
